<template>
    <div>
        <error-notifications :errors="errors"></error-notifications>
        <hcp-notification type="is-success" :message.sync="successMessage"></hcp-notification>
        <form v-on:submit.prevent="upload">
            <div class="field">
                <div class="file" v-bind:class="{'has-name': file}">
                    <label class="file-label">
                        <input class="file-input" type="file" v-on:change="setFile" name="file" required>
                        <span class="file-cta">
                            <span class="file-icon">
                                <i class="fas fa-upload"></i>
                            </span>
                            <span v-if="!file" class="file-label">
                                Choose a file…
                            </span>
                        </span>
                            <span v-if="file" class="file-name">
                                {{file.name}}
                            </span>
                    </label>
                </div>
            </div>
            <div v-if="organizations.length > 1" class="field">
                <div class="control">
                    <label class="label" for="organization-select">Organization this file belongs to</label>
                    <div class="select">
                        <select id="organization-select" v-model="selectedOrganization" required>
                            <option value="">Select an Organization</option>
                            <option v-for="organization in organizations" v-bind:key="organization.id" :value="organization.id">{{organization.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="field">
<!--                        Max width based off Title for organization select.-->
                <div class="control" style="max-width: 33ch;">
                    <label class="label" for="file-description">File Description</label>
                    <textarea v-model="description" id="file-description" class="textarea" placeholder="Describe the file..."></textarea>
                </div>
            </div>
            <div class="field is-grouped">
                <div class="control">
                    <button v-if="progress < 0" class="button is-link">Upload</button>
                    <button v-if="enableCancelButton" @click.prevent="cancel" class="button is-link" type="button">Cancel</button>
                </div>
            </div>
        </form>
        <br>
        <progress v-if="progress >= 0 && progress <= 100" class="progress" :value="progress" max="100" style="width: 100%;">{{progress}}%</progress>
        <progress v-if="progress > 100" class="progress" max="100" style="width: 100%;"></progress>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import axios from "axios";
    import urls from "../urls";
    import ErrorNotifications from "heat-shared/src/components/ErrorNotifications";
    import HcpNotification from "./HcpNotification";

    export default {
        name: "FileUpload",
        components: {HcpNotification, ErrorNotifications},
        data: () => ({
            'errors': [],
            'progress': -1,
            'file': '',
            'selectedOrganization': '',
            'description': '',
            'successMessage': '',
        }),
        computed: {
            ...mapState('user', [
                'organizations',
            ]),
            enableCancelButton(){return false},
        },
        methods: {
            setFile: function (event) {
                this.file = event.target.files[0];
            },
            validateInput() {
                if(!this.file){
                    this.errors = ['You must select a file to upload'];
                    return false;
                }
                if(!this.file.size) {
                    this.errors = ['Please do not upload empty files.'];
                    return false;
                }
                if(this.organizations.length === 1) {
                    this.selectedOrganization = this.organizations[0].id
                }
                if(!this.selectedOrganization){
                    this.errors = ['You must select an organization'];
                    return false;
                }
                return true;
            },
            async upload() {
                if(!this.validateInput()) {
                    return;
                }
                this.$gtag.event('upload', {event_category: 'File', event_label: this.file.name});

                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('name', this.file.name);
                formData.append('description', this.description);
                formData.append('Organization', this.selectedOrganization);
                let me = this;
                try {
                    let response = await  axios.post(urls['files'], formData, {
                        onUploadProgress: function (progressEvent) {
                            if (progressEvent.lengthComputable) {
                                me.progress = progressEvent.loaded / progressEvent.total * 100;
                                //This is because despite sending all the data to the server, we still have to wait for the server to send it on to the S3 bucket
                                if (me.progress > 95) {
                                    me.progress = 101;
                                }
                            }
                        }});
                    this.progress = -1;
                    this.errors = response.data['Errors'] || [];
                    if(!this.errors.length){
                        this.successMessage = "File uploaded successfully";
                        this.$store.dispatch('files/getFiles');
                    }
                } catch (error) {
                    this.progress = -1;
                    console.log(error);
                    this.errors.push("Upload failed");
                }
            },
            cancel() {},
        },
    }
</script>

<style scoped>

</style>
